import { createReducer, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { SessaoState } from '../reduxTypes';
import {
  loginAction,
  logoutAction,
  setSenhaPendenteAction,
  updateEmpresaAction
} from './sessaoActions';

export const initialState: SessaoState = {
  token: null,
  cliente: null,
  empresa: null,
  clienteUsuario: null
};

const sessaoReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(loginAction, (state, action) => {
      return { ...state, ...action.payload };
    })
    .addCase(logoutAction, () => {
      return { ...initialState };
    })
    .addCase(updateEmpresaAction, (state, action) => {
      return { ...state, empresa: action.payload };
    })
    .addCase(setSenhaPendenteAction, (state) => {
      if (!state.clienteUsuario) return state;
      return {
        ...state,
        clienteUsuario: { ...state.clienteUsuario, deveAlterarSenha: true }
      };
    });
});

export default sessaoReducer;
